import { Identifiable } from '../interface/identifiable';
import { Factory } from '../interface/factory';
import { MothershipData } from './mothership-data';
import { Currency } from '../enum/currency';


export interface PaymentSpecificationUi {
  actual: PaymentSpecification;
  periodic?: PeriodicPaymentSpecification;
  spot?: SpotPaymentSpecification;
}

export enum OriginType {
  Addon = 'Addon',
  Product = 'Product',
}

export class Origin {
  type: OriginType;

  constructor(json: any) {
    this.type = json.type;
  }

  static getFactory(): Factory<Origin> {
    return new (class implements Factory<Origin> {
      make(json: any): Origin {
        switch (json.type) {
          case OriginType.Addon:
            return new AddonOrigin(json);
          case OriginType.Product:
            return new ProductOrigin(json);
          default:
            throw new Error('Unrecognized Origin type (' + json.type + ').');
        }
      }

      getTableName(): string {
        throw new Error('Origins are not stored in IndexedDB.');
      }
    })();
  }
}

export class AddonOrigin extends Origin {
  id: string;
  constructor(json: any) {
    super(json);
    this.id = json.id;
  }
}

export class ProductOrigin extends Origin {
  constructor(json: any) {
    super(json);
  }
}

export enum PaymentSpecificationType {
  Periodic = 'Periodic',
  Spot = 'Spot',
  V2 = 'V2',
}

export class PaymentSpecification implements Identifiable {
  type: PaymentSpecificationType;
  id: string;

  paymentId?: string;

  amount: number; // NOTE: After discount.
  currency: Currency;

  mothershipData?: MothershipData;

  origin?: Origin;

  created: Date;
  modified: Date;

  constructor(json: any) {
    this.type = json.type;
    this.id = json.id;

    this.paymentId = json.paymentId ? json.paymentId : undefined;

    this.amount = Number(json.amount);
    this.currency = json.currency as Currency;

    this.mothershipData = json.mothershipData ? new MothershipData(json.mothershipData) : undefined;

    this.origin = json.origin ?  Origin.getFactory().make(json.origin) : undefined;

    this.created = new Date(json.created);
    this.modified = new Date(json.modified);
  }

  public static getFactory(): Factory<PaymentSpecification> {
    return new (class implements Factory<PaymentSpecification> {
      make(json: any): PaymentSpecification {
        switch (json.type) {
          case PaymentSpecificationType.V2:
            return new PeriodicPaymentSpecification(json);
          case PaymentSpecificationType.Periodic:
            return new PeriodicPaymentSpecification(json);
          case PaymentSpecificationType.Spot:
            return new SpotPaymentSpecification(json);
          default:
            throw new Error('Unrecognized PaymentSpecification type (' + json.type + ').');
        }
      }

      getTableName(): string {
        throw new Error('Payment specifications are not stored in IndexedDB.');
      }
    })();
  }
}

export class PeriodicPaymentSpecification extends PaymentSpecification {
  from: Date;
  to: Date;
  constructor(json: any) {
    super(json);
    this.from = new Date(json.from);
    this.to = new Date(json.to);
  }
}

export class SpotPaymentSpecification extends PaymentSpecification {
  date: Date;
  constructor(json: any) {
    super(json);
    this.date = new Date(json.date);
  }
}
